export default __webpack_public_path__ + "static/media/support_back.62722800.png";